import { cateringRequest, cateringRequestHide, cateringUploadsHide } from '@/utils/fetch'

// 拜访记录 添加接口
export function saveVisitRecord(data) {
  const url = '/api/project_visit/save'
  return cateringRequest.post(url, data)
}
